import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MaintScheduleJobsService } from '../../../core/service/maint-schedule-jobs.service';
import { workWeekLabel, btnTxt } from '../../../core/constants/constants';
import { Subscription } from 'rxjs';
import {
  CrewResponse,
  CrewTypeResponse,
  ScheduleJobsDivisionResponse,
  StoredScheduleJobData,
  UnitsByDivisionRequest,
  UnitsByDivisionResponse,
} from '../../../core/interface/maint-schedule-jobs';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../core/service/session-storage';
import { DataService } from '../../../core/service/data_service';
import { LocalStorageService } from '../../../core/service/local-storage.service';
@Component({
  standalone: false,
  selector: 'app-maint-schedule-jobs',
  templateUrl: './maint-schedule-jobs.component.html',
  styleUrl: './maint-schedule-jobs.component.less',
})
export class MaintScheduleJobsComponent implements OnInit, OnDestroy {
  scheduleJobsDivisionList: Array<ScheduleJobsDivisionResponse> = [];
  scheduleJobsCrewList: Array<CrewResponse> = [];
  scheduleJobsCrewTypeList: Array<CrewTypeResponse> = [];
  scheduleJobsUnitList: Array<UnitsByDivisionResponse> = [];
  workWeekLabel = workWeekLabel;
  btnTxt = btnTxt;
  scheduleJobsDivisionSubscription!: Subscription;
  scheduleJobsCrewSubscription!: Subscription;
  scheduleJobsCrewTypeSubscription!: Subscription;
  unitsByDivisionSubscription!: Subscription;
  facilityIdSubscription!: Subscription;
  showCrewTypeLoader: boolean = false;
  showCrewLoader: boolean = false;
  showdivisionLoader: boolean = false;
  showUnitLoader: boolean = false;
  unitNotFound: string = '';
  crewNotFound: string = '';
  divisionNotFound: string = '';
  isLaborhrsChecked: boolean = false;
  isScheduledHrsChecked: boolean = false;
  isCategoryCodeChecked: boolean = false;
  isManPowerHoursChecked: boolean = false;
  wwDate!: Date;
  fac_id!: string;
  localStoredCrewData: StoredScheduleJobData[] = [];
  selectedCrewTypeValue: string | null = null;
  lastSelectedCrewValue: string | null = null;
  selectedCrewValues: string[] = [];
  lastSelectedDivisionValue: string | null = null;
  selectedDivisionValues: string[] = [];
  lastSelectedUnitValue: string | null = null;
  selectedUnitValues: string[] = [];
  userId: string = '';

  disableNonMondays = (current: Date): boolean => {
    return current.getDay() !== 1;
  };

  constructor(
    private readonly maintScheduleJobsService: MaintScheduleJobsService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly router: Router,
    private readonly session: SessionStorageService,
    private readonly dataService: DataService,
    private readonly localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.wwDate = this.maintScheduleJobsService.getMonday(new Date());
    this.fac_id = this.session.getItem('userAccess')
      ? this.session.getItem('userAccess')['faC_ID']
      : '';
    this.userId = this.session.getItem('currentUser')[0].userId;
    this.load();

    this.facilityIdSubscription = this.dataService.getFacilityId.subscribe({
      next: (fac_id: string) => {
        this.fac_id = fac_id;
        this.load();
      },
      error: (error) => {
        console.error('Error Fetching data :', error);
      },
    });
  }

  onDateChange(event: Date) {
    if (event) {
      // Set as local date for UI display
      this.wwDate = new Date(event.getFullYear(), event.getMonth(), event.getDate());
    }
  }

  reset(): void {
    this.showdivisionLoader = true;
    this.showCrewTypeLoader = true;
    this.showCrewLoader = true;
    this.showUnitLoader = true;
    this.scheduleJobsCrewTypeList = [];
    this.scheduleJobsDivisionList = [];
    this.scheduleJobsCrewList = [];
    this.scheduleJobsUnitList = [];
    this.crewNotFound = '';
    this.divisionNotFound = '';
    this.selectedCrewTypeValue = null;
    this.isLaborhrsChecked = false;
    this.isScheduledHrsChecked = false;
    this.isCategoryCodeChecked = false;
    this.isManPowerHoursChecked = false;
  }

  load() {
    this.reset();
    this.scheduleJobsCrewTypeSubscription = this.maintScheduleJobsService
      .getScheduleJobsCrewType(this.fac_id)
      .subscribe({
        next: (response: CrewTypeResponse[]) => {
          let data: CrewTypeResponse[] = response;
          this.scheduleJobsCrewTypeList.push(...data);
          this.changeDetectorRef.detectChanges();
        },
        error: (error) => {
          console.error('Error fetching crew type data: ', error);
        },
        complete: () => {
          this.showCrewTypeLoader = false;
        },
      });
    this.bindLocalData();
    this.getCrewList();
    this.loadDivision();
  }

  bindLocalData() {
    let crewData = this.localStorageService.getItem('scheduleJobsData');
    if (crewData != null) {
      this.localStoredCrewData = JSON.parse(crewData);
      let data: StoredScheduleJobData | undefined =
        this.localStoredCrewData.find(
          (x) => x.facId == this.fac_id && x.userId == this.userId
        );
      this.wwDate = data
        ? new Date(data.selectedDate)
        : this.maintScheduleJobsService.getMonday(new Date());
      this.selectedCrewTypeValue = data ? data.selectedCrewType : '';
      this.selectedCrewValues = data ? data.selectedCrew : [];
      this.selectedDivisionValues = data ? data.selectedDivision : [];
      this.selectedUnitValues = data ? data.selectedUnit : [];
      this.isLaborhrsChecked = data ? data.isLaborhrsChecked : false;
      this.isScheduledHrsChecked = data ? data.isScheduledHrsChecked : false;
      this.isCategoryCodeChecked = data ? data.isCategoryCodeChecked : false;
      this.isManPowerHoursChecked = data ? data.isManPowerHoursChecked : false;
    }
  }

  loadDivision() {
    this.scheduleJobsDivisionSubscription = this.maintScheduleJobsService
      .getScheduleJobsDivision(this.fac_id)
      .subscribe({
        next: (response: ScheduleJobsDivisionResponse[]) => {
          if (response.length === 0) {
            this.divisionNotFound = 'No Record';
          } else {
            this.scheduleJobsDivisionList.push(...response);
          }
          this.loadUnit();
          this.changeDetectorRef.detectChanges();
        },
        error: (error) => {
          console.error('Error fetching division data :', error);
        },
        complete: () => {
          this.showdivisionLoader = false;
        },
      });
  }

  clearDivisionList(): void {
    if (this.selectedDivisionValues.length > 0) {
      this.selectedDivisionValues = [];
      this.divisionNotFound = '';
      this.loadUnit();
    }
  }

  clearUnitList(): void {
    if (this.selectedUnitValues.length > 0) {
      this.selectedUnitValues = [];
      this.unitNotFound = '';
    }
  }

  clearCrewList(): void {
    if (this.selectedCrewValues.length > 0) {
      this.selectedCrewValues = [];
      this.crewNotFound = '';
    }
  }

  clearCrewTypeList(): void {
    if (typeof this.selectedCrewTypeValue === 'string') {
      this.selectedCrewTypeValue = '';
      this.crewNotFound = '';
      this.scheduleJobsCrewList = [];
      this.getCrewList();
    }
  }

  getCrewList() {
    this.showCrewLoader = true;
    this.scheduleJobsCrewSubscription = this.maintScheduleJobsService
      .getScheduleJobsCrew(this.fac_id, this.selectedCrewTypeValue)
      .subscribe({
        next: (response: CrewResponse[]) => {
          this.scheduleJobsCrewList = [];
          if (response.length === 0) {
            this.crewNotFound = 'No Record';
          } else {
            this.scheduleJobsCrewList.push(...response);
            this.changeDetectorRef.detectChanges();
          }
        },
        error: (error) => {
          console.error('Error Fetching data :', error);
        },
        complete: () => {
          this.showCrewLoader = false;
        },
      });
  }

  getScheduleJobsCrewList(crewType: string): void {
    this.scheduleJobsCrewList = [];
    this.showCrewLoader = true;
    this.crewNotFound = '';
    this.selectedCrewTypeValue = crewType;
    this.getCrewList();
  }

  loadUnit(): void {
    this.showUnitLoader = true;
    this.unitNotFound = '';
    this.scheduleJobsUnitList = [];
    let unitPayload: UnitsByDivisionRequest = {
      facId: this.fac_id,
      divId:
        this.selectedDivisionValues.length > 0
          ? this.selectedDivisionValues
          : [],
    };
    this.unitsByDivisionSubscription = this.maintScheduleJobsService
      .getUnitsByDivision(unitPayload)
      .subscribe({
        next: (response: UnitsByDivisionResponse[]) => {
          this.scheduleJobsUnitList = [];
          if (response.length === 0) {
            this.unitNotFound = 'No Record';
          } else {
            this.scheduleJobsUnitList.push(...response);
          }
        },
        error: (error) => {
          console.error('Error fetching unit data :', error);
        },
        complete: () => {
          this.showUnitLoader = false;
        },
      });
  }

  ngOnDestroy(): void {
    if (this.scheduleJobsDivisionSubscription) {
      this.scheduleJobsDivisionSubscription.unsubscribe();
    }
    if (this.scheduleJobsCrewSubscription) {
      this.scheduleJobsCrewSubscription.unsubscribe();
    }
    if (this.scheduleJobsCrewTypeSubscription) {
      this.scheduleJobsCrewTypeSubscription.unsubscribe();
    }
    if (this.unitsByDivisionSubscription) {
      this.unitsByDivisionSubscription.unsubscribe();
    }
    if (this.facilityIdSubscription) {
      this.facilityIdSubscription.unsubscribe();
    }
  }

  seeSchedule(): void {
    const pad = (n: number) => String(n).padStart(2, '0');
    const localDateStr = `${this.wwDate.getFullYear()}-${pad(this.wwDate.getMonth() + 1)}-${pad(this.wwDate.getDate())}T00:00:00`;
    let payload = {
      startDate: localDateStr,
      crew: this.selectedCrewValues.join(';'),
      crewType: this.selectedCrewTypeValue,
      divisions: this.selectedDivisionValues.join(';'),
      units: this.selectedUnitValues.join(';'),
      isLaborhrsIncluded: this.isLaborhrsChecked ? 1 : 0,
      isScheduledHrsincluded: this.isScheduledHrsChecked ? 1 : 0,
      isCategoryCodeScheduled: this.isCategoryCodeChecked ? 1 : 0,
      isManPowerHoursincluded: this.isManPowerHoursChecked ? 1 : 0,
      facId: this.fac_id,
    };

    const storeScheduleJobsData: StoredScheduleJobData = {
      selectedDate: this.wwDate,
      selectedCrew: this.selectedCrewValues,
      selectedCrewType: this.selectedCrewTypeValue,
      selectedDivision: this.selectedDivisionValues,
      selectedUnit: this.selectedUnitValues,
      isLaborhrsChecked: this.isLaborhrsChecked,
      isScheduledHrsChecked: this.isScheduledHrsChecked,
      isCategoryCodeChecked: this.isCategoryCodeChecked,
      isManPowerHoursChecked: this.isManPowerHoursChecked,
      userId: this.userId,
      facId: this.fac_id,
    };

    let localCrewData: StoredScheduleJobData | undefined =
      this.localStoredCrewData.find(
        (x) => x.facId == this.fac_id && x.userId == this.userId
      );

    if (localCrewData == undefined) {
      this.localStoredCrewData.push(storeScheduleJobsData);
    } else {
      let index = this.localStoredCrewData.indexOf(localCrewData);
      this.localStoredCrewData[index] = storeScheduleJobsData;
    }

    this.localStorageService.setItem(
      'scheduleJobsData',
      JSON.stringify(JSON.parse(JSON.stringify(this.localStoredCrewData)))
    );
    this.router.navigateByUrl('/weekly-schedule-mx', {
      state: { data: payload },
    });
  }

  onCrewListitemClick(event: MouseEvent, crew: string): void {
    const { lastSelectedCrew, selectedCrew } = this.multiSelect(
      event,
      crew,
      this.lastSelectedCrewValue,
      this.selectedCrewValues,
      this.scheduleJobsCrewList,
      'crew'
    );
    this.lastSelectedCrewValue = lastSelectedCrew;
    this.selectedCrewValues = selectedCrew;
  }

  onDivisionitemClick(event: MouseEvent, crew: string): void {
    const { lastSelectedCrew, selectedCrew } = this.multiSelect(
      event,
      crew,
      this.lastSelectedDivisionValue,
      this.selectedDivisionValues,
      this.scheduleJobsDivisionList,
      'division'
    );
    this.lastSelectedDivisionValue = lastSelectedCrew;
    this.selectedDivisionValues = selectedCrew;
    this.loadUnit();
  }

  onUnititemClick(event: MouseEvent, crew: string): void {
    const { lastSelectedCrew, selectedCrew } = this.multiSelect(
      event,
      crew,
      this.lastSelectedUnitValue,
      this.selectedUnitValues,
      this.scheduleJobsUnitList,
      'unit'
    );
    this.lastSelectedUnitValue = lastSelectedCrew;
    this.selectedUnitValues = selectedCrew;
  }

  multiSelect(
    event: MouseEvent,
    crew: string,
    lastSelectedCrew: string | null,
    selectedCrew: string[],
    array: any,
    listType: string
  ) {
    const isCtrlKey = event.ctrlKey;
    const isShiftKey = event.shiftKey;
    if (isShiftKey && lastSelectedCrew !== null) {
      if (listType == 'crew') {
        const startIndex = array
          .map((x: any) => x.crew)
          .indexOf(lastSelectedCrew);
        const endIndex = array.map((x: any) => x.crew).indexOf(crew);
        const start = Math.min(startIndex, endIndex);
        const end = Math.max(startIndex, endIndex);
        for (let i = start; i <= end; i++) {
          if (!selectedCrew.includes(array[i].crew)) {
            selectedCrew.push(array[i].crew);
          }
        }
      } else if (listType == 'division') {
        const startIndex = array
          .map((x: any) => x.divisionId)
          .indexOf(lastSelectedCrew);
        const endIndex = array.map((x: any) => x.divisionId).indexOf(crew);
        const start = Math.min(startIndex, endIndex);
        const end = Math.max(startIndex, endIndex);
        for (let i = start; i <= end; i++) {
          if (!selectedCrew.includes(array[i].divisionId)) {
            selectedCrew.push(array[i].divisionId);
          }
        }
      } else if (listType == 'unit') {
        const startIndex = array
          .map((x: any) => x.unitId)
          .indexOf(lastSelectedCrew);
        const endIndex = array.map((x: any) => x.unitId).indexOf(crew);
        const start = Math.min(startIndex, endIndex);
        const end = Math.max(startIndex, endIndex);
        for (let i = start; i <= end; i++) {
          if (!selectedCrew.includes(array[i].unitId)) {
            selectedCrew.push(array[i].unitId);
          }
        }
      }
    } else if (isCtrlKey) {
      if (selectedCrew.includes(crew)) {
        selectedCrew = selectedCrew.filter((c) => c !== crew);
      } else {
        selectedCrew.push(crew);
      }
    } else {
      selectedCrew = [crew];
    }
    lastSelectedCrew = crew;

    return { selectedCrew, lastSelectedCrew };
  }
}
